import { useFetch } from "../../hooks/useFetch";
import { money } from "../../lib/api";
import { Loading, EmptyState } from "../../components/States";
import { PaymentModeBadge } from '../../components/PaymentModeBadge';
import { PageHeader } from "../../components/PageHeader";
import { StatusPill } from "../../components/StageBar";
import { DollarSign } from "lucide-react";

export default function BuilderBilling() {
  const { data, loading } = useFetch("/invoices");
  if (loading) return <Loading />;
  const list = data || [];
  const open = list.filter((i) => ["sent", "overdue"].includes(i.status));

  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Billing" title="Billing" subtitle={`${money(open.reduce((a, i) => a + i.amount, 0))} open balance across ${open.length} invoices.`} />
      <PaymentModeBadge />
      {list.length === 0 ? (
        <EmptyState title="No invoices" icon={DollarSign} />
      ) : (
        <div className="hw-card overflow-hidden">
          <div className="divide-y divide-slate-800">
            {list.map((i) => (
              <div key={i.id} className="flex items-center justify-between gap-4 px-6 py-4" data-testid={`b-invoice-${i.id}`}>
                <div className="flex items-center gap-4">
                  <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${i.status === "overdue" ? "bg-rose-500/15 text-rose-300" : i.status === "paid" ? "bg-emerald-500/15 text-emerald-300" : "bg-sky-500/15 text-sky-300"}`}><DollarSign size={18} /></div>
                  <div>
                    <div className="font-semibold text-white">{i.number}</div>
                    <div className="text-sm text-slate-400">{i.description}</div>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <span className="font-head text-xl font-bold text-white">{money(i.amount)}</span>
                  <StatusPill status={i.status} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
